import { useQuery, UseQueryOptions } from "react-query";
import { AxiosError } from "axios";

import { fetchBrainstormIdeaSynthesis } from "modules/collaboration/api/brainstorming";
import { sendTrackingEvent } from "modules/core/api/tracking";
import { trackingEvents } from "modules/core/config/tracking/events";

import { BrainstormIdeaSynthesisResponse } from "modules/collaboration/types/res";

export const BRAINSTORM_IDEA_SYNTHESIS_QUERY_KEY =
  "/brainstorm_ideas/synthesis";

type BrainstormIdeaSynthesisQueryKey = [
  string,
  { params: { id: string; project_id: string } }
];

export const getBrainstormIdeaSynthesisQueryKey = (params: {
  id: string;
  project_id: string;
}): BrainstormIdeaSynthesisQueryKey => [
  BRAINSTORM_IDEA_SYNTHESIS_QUERY_KEY,
  { params }
];

export const useBrainstormIdeaSynthesisQuery = (
  params: { id: string; project_id: string },
  options: UseQueryOptions<
    BrainstormIdeaSynthesisResponse,
    AxiosError,
    BrainstormIdeaSynthesisResponse,
    BrainstormIdeaSynthesisQueryKey
  > = {}
) => {
  const { onSuccess, ...restOptions } = options;

  return useQuery<
    BrainstormIdeaSynthesisResponse,
    AxiosError,
    BrainstormIdeaSynthesisResponse,
    BrainstormIdeaSynthesisQueryKey
  >({
    queryKey: getBrainstormIdeaSynthesisQueryKey(params),
    queryFn: ({ queryKey: [, { params }] }) =>
      fetchBrainstormIdeaSynthesis(params),
    onSuccess: data => {
      sendTrackingEvent(trackingEvents.ai.synthesized_brainstorm_idea);

      onSuccess?.(data);
    },
    ...restOptions
  });
};
